import { AxiosResponse } from 'axios';
import { SET_EMPLOYEE_OFFBOARDING_TEMPLATES, SET_EMPLOYEE_OFFBOARDING_TEMPLATE, SET_ERRORMSG } from '@/store/mutation_types';
import {
  CLEAR_EMPLOYEE_OFFBOARDING_TEMPLATE_ISLOADING,
  DELETE_EMPLOYEE_OFFBOARDING_TEMPLATE,
  EDIT_EMPLOYEE_OFFBOARDING_TEMPLATE,
  GET_EMPLOYEE_OFFBOARDING_TEMPLATES,
  GET_EMPLOYEE_OFFBOARDING_TEMPLATE,
  REGISTER_EMPLOYEE_OFFBOARDING_TEMPLATE,
} from '@/store/action_types';
import { StateObject } from '@/dtos/state.dto';
import EmployeeOffboardingTemplate from '@/services/employee_offboarding_template';
import { Module } from 'vuex';
import {
  EditEmployeeOffboardingTemplate,
  RegisterEmployeeOffboardingTemplate,
  GetEmployeeOffboardingTemplate,
} from '@/dtos/employee_offboarding_template.dto';

const employeeOffboardingTemplate: Module<any, {}> = {
  state: {
    employeeOffboardingTemplate: {
      data: null,
      isLoading: false,
    },
    employeeOffboardingTemplates: {
      data: null,
      isLoading: false,
    },
  },
  getters: {
    employeeOffboardingTemplate: (state: { employeeOffboardingTemplate: any }) => state.employeeOffboardingTemplate,
    employeeOffboardingTemplates: (state: { employeeOffboardingTemplates: any }) => state.employeeOffboardingTemplates,
  },
  mutations: {
    [SET_EMPLOYEE_OFFBOARDING_TEMPLATE]: (
      state: { employeeOffboardingTemplate: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.employeeOffboardingTemplate.data = payload.data) : null,
        (state.employeeOffboardingTemplate.isLoading = payload.isLoading);
    },
    [SET_EMPLOYEE_OFFBOARDING_TEMPLATES]: (
      state: { employeeOffboardingTemplates: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.employeeOffboardingTemplates.data = payload.data) : null,
        (state.employeeOffboardingTemplates.isLoading = payload.isLoading);
    },
  },
  actions: {
    [REGISTER_EMPLOYEE_OFFBOARDING_TEMPLATE]: async ({ commit }: any, payload: any) => {
      commit(SET_EMPLOYEE_OFFBOARDING_TEMPLATE, { data: null, isLoading: true });

      const result: AxiosResponse = await EmployeeOffboardingTemplate.registerEmployeeOffboardingTemplate(
        payload as RegisterEmployeeOffboardingTemplate
      );

      if (result) {
        if (result.data.status) {
          commit(SET_EMPLOYEE_OFFBOARDING_TEMPLATE, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_EMPLOYEE_OFFBOARDING_TEMPLATE, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_EMPLOYEE_OFFBOARDING_TEMPLATE, { isLoading: false });
        return false;
      }
    },
    [GET_EMPLOYEE_OFFBOARDING_TEMPLATES]: async ({ commit }: any, payload: any) => {
      commit(SET_EMPLOYEE_OFFBOARDING_TEMPLATES, { data: null, isLoading: true });

      const result: AxiosResponse = await EmployeeOffboardingTemplate.getEmployeeOffboardingTemplates(
        payload as GetEmployeeOffboardingTemplate
      );

      if (result) {
        if (result.data.status) {
          commit(SET_EMPLOYEE_OFFBOARDING_TEMPLATES, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_EMPLOYEE_OFFBOARDING_TEMPLATES, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_EMPLOYEE_OFFBOARDING_TEMPLATES, { isLoading: false });
        return false;
      }
    },
    [GET_EMPLOYEE_OFFBOARDING_TEMPLATE]: async ({ commit }: any, payload: any) => {
      commit(SET_EMPLOYEE_OFFBOARDING_TEMPLATE, { data: null, isLoading: true });

      const result: AxiosResponse = await EmployeeOffboardingTemplate.getEmployeeOffboardingTemplates(
        payload as GetEmployeeOffboardingTemplate
      );

      if (result) {
        if (result.data.status) {
          commit(SET_EMPLOYEE_OFFBOARDING_TEMPLATE, { data: result.data.data[0], isLoading: false });
          return true;
        }
        commit(SET_EMPLOYEE_OFFBOARDING_TEMPLATE, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_EMPLOYEE_OFFBOARDING_TEMPLATE, { isLoading: false });
        return false;
      }
    },
    [EDIT_EMPLOYEE_OFFBOARDING_TEMPLATE]: async ({ commit }: any, payload: any) => {
      commit(SET_EMPLOYEE_OFFBOARDING_TEMPLATE, { data: null, isLoading: true });

      const result: AxiosResponse = await EmployeeOffboardingTemplate.editEmployeeOffboardingTemplate(
        payload as EditEmployeeOffboardingTemplate
      );

      if (result) {
        if (result.data.status) {
          commit(SET_EMPLOYEE_OFFBOARDING_TEMPLATE, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_EMPLOYEE_OFFBOARDING_TEMPLATE, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_EMPLOYEE_OFFBOARDING_TEMPLATE, { isLoading: false });
        return false;
      }
    },
    [DELETE_EMPLOYEE_OFFBOARDING_TEMPLATE]: async ({ commit }: any, payload: string) => {
      commit(SET_EMPLOYEE_OFFBOARDING_TEMPLATE, { data: null, isLoading: true });

      const result: AxiosResponse = await EmployeeOffboardingTemplate.deleteEmployeeOffboardingTemplate(payload);

      if (result) {
        if (result.data.status) {
          commit(SET_EMPLOYEE_OFFBOARDING_TEMPLATE, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_EMPLOYEE_OFFBOARDING_TEMPLATE, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_EMPLOYEE_OFFBOARDING_TEMPLATE, { isLoading: false });
        return false;
      }
    },
    [CLEAR_EMPLOYEE_OFFBOARDING_TEMPLATE_ISLOADING]: ({ commit }) => {
      commit(SET_EMPLOYEE_OFFBOARDING_TEMPLATE, { isLoading: false });
      commit(SET_EMPLOYEE_OFFBOARDING_TEMPLATES, { isLoading: false });
    },
  },
};

export default employeeOffboardingTemplate;
